export default "__VITE_ASSET__DwndfkqL__"